module.exports = __webpack_public_path__ + "static/media/Crotone.7b38895a.png";